import { IconProps } from '../icons';
import { themeColors } from '@styles/theme';

export const SaveRouteAsSelectionSetIcon = ({
    width = 24,
    height = 24,
    color = themeColors.grey,
}: IconProps) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect
                x="3.5"
                y="3.5"
                width="17"
                height="17"
                rx="2"
                stroke={color}
                strokeWidth="1.5"
                strokeDasharray="3 2"
            />
            <path
                d="M6.8 14.4L10 10.6L13.4 12.6L16.6 8.2"
                stroke={color}
                strokeWidth="1.3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <circle cx="6.8" cy="14.4" r="1.05" fill={color} />
            <circle cx="10" cy="10.6" r="1.05" fill={color} />
            <circle cx="13.4" cy="12.6" r="1.05" fill={color} />
            <circle cx="16.6" cy="8.2" r="1.05" fill={color} />
            <path
                d="M18 14.25V17.25M16.5 15.75H19.5"
                stroke={color}
                strokeWidth="1.5"
                strokeLinecap="round"
            />
        </svg>
    );
};
